import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Row, Col } from 'react-bootstrap';
import '../Styles/destination.css';

export default class Munnar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'overview'
    };
  }

  render() {
    const attractions = [
      {
        name: "Eravikulam National Park",
        image: "/assets/img/eravikulam.jpg",
        description: "Famous for endangered Nilgiri Tahr, spread over 97 sq. km. Home to rare butterflies, animals, and birds. The Neelakurinji flowers bloom here once in 12 years.",
        highlight: "Endangered Nilgiri Tahr",
        bestTime: "Sep-Nov"
      },
      {
        name: "Anamudi Peak",
        image: "/assets/img/anamudi.jpg",
        description: "Highest peak in South India standing at over 2700 m. Ideal spot for trekking with permission from Forest authorities.",
        highlight: "Highest Peak in South India",
        bestTime: "Oct-Feb"
      },
      {
        name: "Mattupetty",
        image: "/assets/img/Mattupetty.jpg",
        description: "Known for storage masonry dam and beautiful lake offering boat rides. Home to Indo-Swiss Livestock Project with high yielding cows.",
        highlight: "Boating & Dairy Farm",
        bestTime: "All Year"
      },
      {
        name: "Top Station",
        image: "/assets/img/top-station.jpeg",
        description: "Highest point on Munnar-Kodaikanal road at 1700 m. Offers panoramic views of Tamil Nadu. Best spot to see Neelakurinji flowers.",
        highlight: "Panoramic Valley Views",
        bestTime: "Aug-Oct"
      },
      {
        name: "Tea Museum",
        image: "/assets/img/tea-museum.png",
        description: "Museum showcasing the origins and evolution of tea plantations. Houses curios, photographs, and machineries from Tata Tea's Nallathanni Estate.",
        highlight: "Tea Plantation History",
        bestTime: "All Year"
      },
      {
        name: "Chinnakanal & Anayirangal",
        image: "/assets/img/chinnakanal.jpg",
        description: "Power House Waterfalls cascading down 2000 m. Anayirangal offers lush tea plantations and splendid reservoir boat trips.",
        highlight: "Waterfalls & Tea Gardens",
        bestTime: "Oct-Feb"
      },
      {
        name: "Pallivasal",
        image: "/assets/img/pallivasal.jpg",
        description: "Venue of the first Hydro-electric project in Kerala. A place of immense scenic beauty and popular picnic spot.",
        highlight: "First Hydro-electric Project",
        bestTime: "All Year"
      },
      {
        name: "Meesapulimala",
        image: "/assets/img/meesapulimala.jpg",
        description: "Second highest peak in South India offering spectacular trekking experiences through rhododendron forests.",
        highlight: "Trekking Paradise",
        bestTime: "Oct-Mar"
      }
    ];

    const quickInfo = [
      { label: "Elevation", value: "1,600 m above sea level", icon: "fas fa-mountain" },
      { label: "Best Time to Visit", value: "September to March", icon: "fas fa-calendar-alt" },
      { label: "Nearest Airport", value: "Cochin International Airport (108 km)", icon: "fas fa-plane" },
      { label: "Nearest Railway", value: "Aluva (108 km) / Angamali (109 km)", icon: "fas fa-train" },
      { label: "Temperature", value: "10°C to 25°C", icon: "fas fa-temperature-low" },
      { label: "Famous For", value: "Tea Plantations, Neelakurinji", icon: "fas fa-leaf" }
    ];

    return (
      <div className="dest-destination-page">
        {/* Hero Section */}
        <div className="destination-hero">
          <div className="dest-hero-overlay"></div>
          <div className="dest-hero-background">
            <img src="/assets/img/tea-plantation.jpg" alt="Munnar Hills" />
          </div>
          <div className="dest-hero-content">
            <div className="dest-hero-badge">
              <span>God's Own Country</span>
            </div>
            <h1 className="dest-hero-title">Munnar</h1>
            <p className="dest-hero-subtitle">
              Where misty mountains meet endless tea gardens
            </p>
            <div className="dest-hero-location">
              <i className="fas fa-map-marker-alt"></i>
              <span>Idukki District, Kerala, India</span>
            </div>
          </div>
          <div className="dest-hero-scroll">
            <span>Scroll to explore</span>
            <i className="fas fa-chevron-down"></i>
          </div>
        </div>

        {/* Introduction Section */}
        <div className="dest-intro-section">
          <Grid>
            <Row>
              <Col xs={12} md={7} className="dest-intro-text">
                <h2 className="dest-section-title">Welcome to Munnar</h2>
                <p className="dest-intro-description">
                  Munnar is situated at the confluence of three mountain streams - Mudrapuzha, 
                  Nallathanni and Kundala. Located 1,600 m above sea level, this hill station 
                  was once the summer resort of the erstwhile British Government in South India.
                </p>
                <p className="dest-intro-description">
                  Sprawling tea plantations, picture-book towns, winding lanes and holiday facilities 
                  make this a popular resort town. Among the exotic flora found in the forests and 
                  grasslands here is the Neelakurinji. This flower which bathes the hills in blue 
                  once in every twelve years, bloomed last in 2018 and will next bloom in 2030.
                </p>
                <div className="dest-highlight-box">
                  <i className="fas fa-star"></i>
                  <span>Did You Know? Munnar is home to Anamudi, the highest peak in South India at 2,695 m</span>
                </div>
              </Col>
              <Col xs={12} md={5} className="dest-quick-info">
                <h3>Quick Facts</h3>
                <div className="dest-info-grid">
                  {quickInfo.map((info, index) => (
                    <div key={index} className="dest-info-card">
                      <div className="dest-info-icon">
                        <i className={info.icon}></i>
                      </div>
                      <div className="dest-info-content">
                        <span className="dest-info-label">{info.label}</span>
                        <span className="dest-info-value">{info.value}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Attractions Section */}
        <div className="dest-attractions-section">
          <div className="dest-section-header">
            <h2 className="dest-section-title-centered">Top Attractions in Munnar</h2>
            <p className="dest-section-subtitle">
              Discover the most beautiful places that make Munnar a paradise for nature lovers
            </p>
          </div>

          <Grid>
            <Row className="dest-attractions-grid">
              {attractions.map((attraction, index) => (
                <Col xs={12} sm={6} md={4} lg={3} key={index} className="dest-attraction-col">
                  <div className="dest-attraction-card">
                    <div className="dest-card-image">
                      <img src={attraction.image} alt={attraction.name} />
                      <div className="dest-card-overlay">
                        <span className="dest-highlight-tag">{attraction.highlight}</span>
                      </div>
                    </div>
                    <div className="dest-card-content">
                      <h3 className="dest-attraction-name">{attraction.name}</h3>
                      <p className="dest-attraction-description">{attraction.description}</p>
                      <div className="dest-card-footer">
                        <span className="dest-best-time">
                          <i className="far fa-calendar"></i>
                          Best: {attraction.bestTime}
                        </span>
                        <button className="dest-read-more-btn">Read More</button>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Tea Plantation Section */}
        <div className="dest-tea-section">
          <div className="dest-tea-overlay"></div>
          <Grid>
            <Row>
              <Col xs={12} md={6} className="dest-tea-content">
                <div className="dest-tea-badge">Heritage</div>
                <h2 className="dest-tea-title">The Tea Legacy of Munnar</h2>
                <p className="dest-tea-description">
                  Munnar has a legacy of its own when it comes to the origins and evolution of tea plantations. 
                  Taking account of this legacy and to preserve and showcase some of the exquisite and interesting 
                  aspects on the genesis and growth of tea plantations in Kerala's high ranges, a museum exclusively 
                  for tea was opened by Tata Tea in Munnar.
                </p>
                <p className="dest-tea-description">
                  This Tea Museum houses curios, photographs and machineries; all of which have a story to tell 
                  on the origins and growth of tea plantations in Munnar. The museum is located at the Nallathanni 
                  Estate of Tata Tea and is worth a visit.
                </p>
                <div className="dest-tea-stats">
                  <div className="dest-stat">
                    <span className="dest-number">100+</span>
                    <span className="dest-label">Years of Tea Heritage</span>
                  </div>
                  <div className="dest-stat">
                    <span className="dest-number">50,000+</span>
                    <span className="dest-label">Acres of Tea Gardens</span>
                  </div>
                  <div className="dest-stat">
                    <span className="dest-number">20+</span>
                    <span className="dest-label">Tea Estates</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Neelakurinji Section */}
        <div className="dest-kurinji-section">
          <Grid>
            <Row>
              <Col xs={12} md={6} className="dest-kurinji-content">
                <div className="dest-kurinji-badge">Rare Phenomenon</div>
                <h2 className="dest-kurinji-title">The Neelakurinji Blooms</h2>
                <p className="dest-kurinji-description">
                  The Neelakurinji (Strobilanthes kunthiana) is a unique flower that blooms once every twelve years, 
                  painting the hills of Munnar in a spectacular shade of blue. This rare phenomenon attracts thousands 
                  of visitors who come to witness nature's incredible spectacle.
                </p>
                <p className="dest-kurinji-description">
                  The next blooming season is expected in 2030, making it a once-in-a-lifetime experience for many. 
                  The best spots to witness this natural wonder include Eravikulam National Park, Top Station, and 
                  the rolling hills surrounding Munnar.
                </p>
                <div className="dest-kurinji-fact">
                  <i className="fas fa-info-circle"></i>
                  <span>Last bloomed in 2018 • Next bloom in 2030</span>
                </div>
              </Col>
              <Col xs={12} md={6} className="dest-kurinji-image">
                <div className="dest-image-card">
                  <img src="/assets/img/neelakurinji.jpg" alt="Neelakurinji Flowers" />
                  <div className="dest-image-caption">Neelakurinji in full bloom - A once in 12 years spectacle</div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Travel Tips Section */}
        <div className="dest-tips-section">
          <Grid>
            <div className="dest-section-header">
              <h2 className="dest-section-title-centered">Travel Tips for Munnar</h2>
              <p className="dest-section-subtitle">Make the most of your visit to this beautiful hill station</p>
            </div>
            <Row className="dest-tips-grid">
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-umbrella-beach"></i>
                  </div>
                  <h4>Best Season</h4>
                  <p>September to March offers pleasant weather with clear skies and lush greenery</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-tshirt"></i>
                  </div>
                  <h4>What to Wear</h4>
                  <p>Light woolens in winter, comfortable cotton in summer. Carry a jacket for evenings</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-car"></i>
                  </div>
                  <h4>Getting Around</h4>
                  <p>Taxi services and private vehicles are best for exploring the hill station</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-camera"></i>
                  </div>
                  <h4>Must Try</h4>
                  <p>Fresh tea tasting, homemade chocolates, and authentic Kerala cuisine</p>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* CTA Section */}
        <div className="dest-cta-section">
          <div className="dest-cta-content">
            <h3>Plan Your Munnar Getaway</h3>
            <p>Let us help you create unforgettable memories in the Queen of Hill Stations</p>
            <Link to="/contact" className="dest-cta-button">
              Book Your Trip
              <i className="fas fa-arrow-right"></i>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}